import React from 'react'
import _ from 'lodash'
import { Script } from '../../Project/ProjectUI/AsssetsManager'

//@todo need finish update
export const IonIcon = ({ icon, color, size, style, className, ...rest }) => {
  return (
    <>
      <Script type="module" src="https://cdn.jsdelivr.net/npm/ionicons@7.4.0/dist/ionicons/ionicons.esm.js" />
      <Script nomodule src="https://cdn.jsdelivr.net/npm/ionicons@7.4.0/dist/ionicons/ionicons.js" />
      <ion-icon
        name={_.last(String(icon).split('##'))}
        class={className}
        style={Object.assign(
          {
            fontSize: size,
            minWidth: '1em',
            minHeight: '1em',
            fill: 'var(--ft-icon-fill, currentColor)',
            color: 'var(--ft-icon-fill, currentColor)',
          },
          style
        )}
        {...rest}
      />
    </>
  )
}
